export default "__VITE_ASSET__DfOOfPBX__"